var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiTipthu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.2C3.5 2.53726 4.03726 2 4.7 2H10.25L14.5 6.25V15.8C14.5 16.4627 13.9627 17 13.3 17H4.7C4.03726 17 3.5 16.4627 3.5 15.8V3.2Z",
    stroke: "#B8ADAF",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 2V5.55C10.25 5.93726 10.5627 6.25 10.95 6.25H14.5",
    stroke: "#B8ADAF",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 9.4H10.8",
    stroke: "#B8ADAF",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 12.1H9.1",
    stroke: "#B8ADAF",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.35 14.85L16.05 10.15C16.35 9.85 16.35 9.36 16.05 9.06L15.44 8.45C15.14 8.15 14.65 8.15 14.35 8.45L9.65 13.15V14.85H11.35Z",
    stroke: "#B8ADAF",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiTipthu);
export default __webpack_public_path__ + "static/media/mi-tipthu.a31907598e9e0bdde7693676ffdf8261.svg";
export { ForwardRef as ReactComponent };